// Strip Trailing Slash from the URL

export function stripTrailingSlash(pageURL: string)
{
    return pageURL.endsWith('/') ?
        pageURL.slice(0, -1) :
        pageURL;
}
